// extracted by mini-css-extract-plugin
export var heroImage = "_cr-1";
export var modal = "_cr-0";